import $ from 'jquery'
import {lockBody, unlockBody} from '../utils';

$('.js-team-member').on('click', function() {
    if (!$(event.target).hasClass('js-close-bio')) {
        $('.js-old').addClass('is-inactive');
        $('.js-bio').removeClass('is-active');
        $(this).find('.js-bio').addClass('is-active');

        $('.js-team-member').removeClass('is-active');
        $('.js-team-member').removeClass('is-inactive');
        $('.js-team-member').not($(this)).addClass('is-inactive');
        $(this).addClass('is-active');
        lockBody()

        /*if ($(window).width() < 768) {
            var trainingHeight = $(this).find('.feed-team_member__biography--training').outerHeight();
            var maxHeight = 166;

            if (trainingHeight > maxHeight) {
                $(this).find('.feed-team_member__biography--text').css('margin-top', maxHeight * -1);
            } else {
                $(this).find('.feed-team_member__biography--text').css('margin-top', trainingHeight * -1);
            }
        } else {
            $(this).find('.feed-team_member__biography--text').css('margin-top', 0);
        }*/
    }
});

$('html').on('click', function(event) {
    if ($('.pt-team').length > 0) {
        if (!$(event.target).closest('.js-team-member.is-active').length) {
            $('.is-active').removeClass('is-active');
            $('.is-inactive').removeClass('is-inactive');
            unlockBody()
        }
    }
});

$('.js-close-bio').on('click', function(event) {
    $('.is-active').removeClass('is-active');
    $('.is-inactive').removeClass('is-inactive');
    unlockBody()
});

